import React from 'react';
import { VideoButton } from '../../components/VideoButton';
import { useFullscreen } from '../../utils/hooks/useFullscreen';
import { useIOSFullscreen } from '../../utils/hooks/useIOSFullscreen';

export const FullscreenButton = ({ isFullscreen, toggleFullscreen }) => {
    return (
        <VideoButton className='fullscreen-button'
                     active={ isFullscreen }
                     name={ isFullscreen ? 'arrows-in' : 'arrows-out-shadow' }
                     onClick={ toggleFullscreen } />
    )
}
